import { useMutation } from '@tanstack/react-query';
import APIClient from '@/services/APIClient';
import BaseServices from '@/services/BaseServices';

const useESewaCheckout = ({
  cb,
  cbSuccess,
  cbError,
}: IMutationHookProps<PaymentCheckoutResponse>) => {
  return useMutation<
    PaymentCheckoutResponse,
    CustomError<RevelErrorResponse>,
    PaymentCheckoutRequest<ESewaCheckoutPayload>
  >({
    mutationFn: ({ businessId, payload }) => {
      const apiClient = new APIClient<ESewaCheckoutPayload>(
        BaseServices.PAYMENT_SERVICE,
        `/payment/business/${businessId}/esewa-web/checkout`,
      );
      return apiClient.post<PaymentCheckoutResponse>(payload);
    },
    onMutate: cb,
    onSuccess: cbSuccess,
    onError: cbError,
  });
};

export default useESewaCheckout;
